import Const from 'constants';

const defaultStateData = {
    inner: {
        min: Const.DEFAULT_VALUE_FOR_MIN_PROJECTED_OWNERSHIP_CAP,
        max: Const.DEFAULT_VALUE_FOR_MAX_PROJECTED_OWNERSHIP_CAP,
    },
    outer: {
        min: Const.DEFAULT_VALUE_FOR_MIN_PROJECTED_OWNERSHIP_CAP,
        max: Const.DEFAULT_VALUE_FOR_MAX_PROJECTED_OWNERSHIP_CAP,
    },
};

const defaultState = {
    data: cp(defaultStateData),
    isInnerMinEqual(value) {
        return this.getInnerMin() === Number(value);
    },
    isInnerMaxEqual(value) {
        return this.getInnerMax() === Number(value);
    },
    isInnerMinDefault() {
        return this.getInnerMin() === Const.DEFAULT_VALUE_FOR_MIN_PROJECTED_OWNERSHIP_CAP;
    },
    getInnerCapBoundaries() {
        return {...this.data.inner};
    },
    getInnerCapBoundary(capName) {
        return Number(this.data.inner[capName]);
    },
    getOuterCapBoundary(capName) {
        return Number(this.data.outer[capName]);
    },
    getInnerMin() {
        return this.getInnerCapBoundary('min');
    },
    getInnerMax() {
        return this.getInnerCapBoundary('max');
    },
    getOuterMin() {
        return this.getOuterCapBoundary('min');
    },
    getOuterMax() {
        return this.getOuterCapBoundary('max');
    },
};

export default function (state = defaultState, action) {
    if (action.type === Const.PROJECTED_OWNERSHIP_CAP_SET_INNER) {
        state = {...state};

        state.data.inner = {
            ...state.data.inner,
            ...action.items,
        };
    } else if (inArray(action.type, [Const.RESET_ALL_SETTINGS, Const.FILTER_BY_SLATE])) {
        state = {
            ...defaultState,
            data: cp(defaultStateData),
        };
    }

    return state;
}
